<div *ngIf="!bypass" class="row m-0 justify-content-center">
    <div class="col-lg-6 r-5 p-0 d-flex justify-content-center">
        <button  style="width: 300px;" id="acceptButton" [disabled]="!(isChecked && petitionError===false)"
            (click)="redirectToEidas()">{{'HOME.CONTINUE_EIDAS' | translate}}</button>
    </div>
</div>
<div aria-hidden="true" *ngIf="bypass" style="width: 5px; background-color: white; border-radius: 5px; height: 100%;" (click)="byPassEidas()" class="">
</div>